import { useEffect, useState } from 'react';
import { Button } from '@upmc/ims.component-library';

import StyleAuxiliary from '../../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import { Actions } from '../../../../../components/UI/MDC/Card/Card';
import MaterialIcon from '@material/react-material-icon';
import { NOT_SAVED_ALERT } from './_constants';
import { useHistory } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { TitleCase } from '../../../../../utils/strings/StringUtil';
import { CMS_Roles } from '../../../CMS_Constants';

const FooterControls = props => {
	const [contextMenuAnchor, setContextMenuAnchor] = useState(null);
	const isOptionMenuOpen = Boolean(contextMenuAnchor);
	const [statusTypes, setStatusTypes] = useState({});
	const [saveStatusWasSelected, setSaveStatusWasSelected] = useState(false);
	useEffect(() => {
		if (
			props.currentUser.userProfile.Roles &&
			props.updateObject.StatusTypes
		) {
			setStatusTypesBasedOnCurrentUser(props.updateObject.StatusTypes);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.updateObject, props.currentUser]);

	useEffect(() => {
		if (saveStatusWasSelected) {
			props.handleSave();
			setSaveStatusWasSelected(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [saveStatusWasSelected]);

	let history = useHistory();
	const navigateBack = () => {
		if (props.wasEdited) {
			if (window.confirm(NOT_SAVED_ALERT)) {
				history.push(`/CMSManagement`);
			}
		} else {
			history.push(`/CMSManagement`);
		}
	};

	const setStatusTypesBasedOnCurrentUser = Statustypes => {
		if (
			props.currentUser.userProfile.Roles.find(
				x => x.Search === CMS_Roles.Admin.Search
			)
		) {
			setStatusTypes(Statustypes);
		} else {
			let modifiedStatusTypes = removeApprovedOption(Statustypes);
			setStatusTypes(modifiedStatusTypes);
		}
	};

	const removeApprovedOption = StatusTypes => {
		Object.keys(StatusTypes).forEach(key => {
			if (StatusTypes[key] === 'Approved') {
				delete StatusTypes[key];
			}
		});
		return StatusTypes;
	};

	const openSaveOptions = e => {
		setContextMenuAnchor(e.currentTarget);
	};

	const closeSaveOptions = () => {
		setContextMenuAnchor(null);
	};

	const handleStatusOptionSelect = e => {
		props.setUpdateObject({
			...props.updateObject,
			Status: statusTypes[e.target.value],
		});

		setSaveStatusWasSelected(true);
		//do this last
		closeSaveOptions();
	};

	const MenuItemIsSelected = key => {
		if (props.updateObject.Status === statusTypes[key]) {
			return true;
		} else {
			return false;
		}
	};

	return (
		<StyleAuxiliary classes={props.Styles.footer}>
			<Actions>
				<Button
					sx={{ m: '5px' }}
					onClick={e => navigateBack(e)}
					variant='outlined'
				>
					Back To Dashboard
				</Button>

				{props.editable ? (
					<Button
						onClick={() => {
							if (
								window.confirm(
									'Are you sure you want to cancel? All unsaved changes will be lost.'
								)
							) {
								props.setWasEdited(false);
								props.setEditable(!props.editable);
								props.resetForm();
							}
						}}
						variant='outlined'
						startIcon={<MaterialIcon icon='cancel' />}
						sx={{ m: '5px' }}
					>
						Cancel
					</Button>
				) : (
					<Button
						onClick={() => {
							props.setEditable(!props.editable);
						}}
						variant='outlined'
						startIcon={<MaterialIcon icon='edit' />}
						hidden={props.new}
						sx={{ m: '5px' }}
					>
						Edit
					</Button>
				)}

				<Button
					onClick={e => openSaveOptions(e)}
					disabled={props.validationErrors.length > 0}
					startIcon={<MaterialIcon icon='save' />}
					sx={{ m: '5px' }}
				>
					Save
				</Button>
				<Menu
					id='Save-Options'
					aria-labelledby='FooterControls'
					anchorEl={contextMenuAnchor}
					open={isOptionMenuOpen}
					onClose={() => closeSaveOptions()}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{statusTypes
						? Object.keys(statusTypes).map((key, index) => {
								return (
									<MenuItem
										id={index}
										key={index}
										onClick={e =>
											handleStatusOptionSelect(e)
										}
										value={key}
										selected={MenuItemIsSelected(key)}
									>
										{TitleCase(statusTypes[key])}
									</MenuItem>
								);
						  })
						: null}
				</Menu>
			</Actions>
		</StyleAuxiliary>
	);
};

export default FooterControls;
